import { useEffect, useState } from 'react'

export default function useMediaQuery(query: string) {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Safari <14
    if ('addEventListener' in mql) {
      mql.addEventListener('change', onChange);
    } else {
      // @ts-ignore
      mql.addListener(onChange);
    }
    setMatches(mql.matches);
    return () => {
      if ('removeEventListener' in mql) {
        mql.removeEventListener('change', onChange);
      } else {
        // @ts-ignore
        mql.removeListener(onChange);
      }
    }
  }, [query]);

  return matches;
}
